import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import FMPHeadline from '../../components/ui/FMPHeadline';
import Button from '@material-ui/core/Button';
import Search from '@material-ui/icons/Search';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';
import StationsContainer from '../../containers/Stations';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';
import SuppliersContainer from '../../containers/logistics/Suppliers';

import FMPSelect from '../../components/pureForm/FMPSelect';
import { showErrors } from '../../modules/general';

import quickbooksLogo from '../../images/quickbooksLogo.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormComponent from '../../components/FormComponent';
import { post } from '../../modules/utility';
import EnhancedTable from '../../components/table/EnhancedTable';
import WarningIcon from '@material-ui/icons/Warning';
import { getSharedStyles } from '../../themes';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import FMPCheckbox from '../../components/pureForm/FMPCheckbox';
import FMPMonthYearPicker from '../../components/pureForm/FMPMonthYearPicker';
import { formatStationCogs, formatBulkCogs } from './profitReportUtil';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import Typography from '@material-ui/core/Typography';
import TruckIcon from '@material-ui/icons/LocalShipping';
import InvoiceIcon from '@material-ui/icons/Receipt';

const isLocalhost = Boolean(window.location.hostname === 'localhost');

const styles = (theme) => {
	return {
		...getSharedStyles(theme),
		icon: {
			marginRight: 5,
		},
		linkedItem: {
			fontSize: 14,
			textDecoration: 'none',
			display: 'flex',
			alignItems: 'center',
		},
		openLink: {
			paddingLeft: 4,
			width: 14,
			height: 14,
		},
		diffError: {
			fontWeight: 900,
			color: '#FF500F',
		},
		contractSub: {
			paddingLeft: 10,
			fontSize: 14,
			color: '#666',
		},
		todo: {
			border: `1px solid #bbb`,
			color: '#666',
			padding: 5,
			fontStyle: 'italic',
		},

		bigButton: {
			borderRadius: '100px',
			padding: '18px 34px',
			fontSize: 16,
		},
		smallButton: {
			borderRadius: '100px',
			fontWeight: 200,
		},
		pickPlease: {
			background: '#F7F7F7',
			border: '1px solid #DDDDDD',
			padding: 20,
			color: '#666',
		},
		divider: {
			borderBottom: '1px dashed #dddddd',
			marginBottom: 25,
			marginTop: 25,
		},
		stats: {
			padding: '20px 10px 20px 10px',
			borderBottom: '1px solid #ddd',
			marginBottom: 10,
		},
		statGroup: {
			padding: '5px 5px 10px 5px',
			borderBottom: '1px solid #eee',
			marginBottom: 10,
		},
		available: {
			fontWeight: 900,
		},
		quickbooksIcon: {
			display: 'inline-block',
			width: 40,
			height: 40,
			backgroundImage: `url('${quickbooksLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		table: {
			width: '100%',
			tableLayout: 'auto',
		},
		row: {
			cursor: 'pointer',
		},
		button: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		resultsHere: {
			padding: 30,
			backgroundColor: '#f1f1f1',
			color: '#777',
			borderRadius: 10,
		},
		runningSearch: {
			paddingLeft: 20,
			display: 'flex',
			alignItems: 'center',
			fontSize: 18,
			color: '#666',
		},
		terminalSupplier: {
			borderLeft: '2px solid #ccc',
			paddingLeft: 5,
			marginBottom: 7,
		},
		fuelGroup: {
			marginBottom: 7,
		},
		warningIcon: {
			color: '#FFC107',
			width: 16,
			height: 16,
			paddingRight: 5,
			borderRight: '1px solid #f1f1f1',
			verticalAlign: 'middle',
		},
	};
};

const stationColumns = [
	{
		sortId: 'status',
		displayId: 'statusDisplay',
		label: 'Status',
	},
	{
		sortId: 'deliveryDateSort',
		displayId: 'deliveryDisplay',
		label: 'Delivery Info',
	},
	{
		sortId: 'deliveryDateSort2',
		displayId: 'invoiceDisplay',
		label: 'Invoice / Rack Transfer Info',
	},
	{
		sortId: 'deliveryDateSort3',
		displayId: 'vendorBillDisplay',
		label: 'Vendor Bill Info',
	},
	{
		sortId: 'totalInvoiceE85LineItemCost',
		displayId: 'invoiceAmountsDisplay',
		label: 'Invoice Amounts',
	},
	{
		sortId: 'fuelCostPerGallon',
		displayId: 'fuelCogsDisplay',
		label: 'Fuel COGs',
		// }, {
		//	sortId: 'freightCostPerGallon',
		//	displayId: 'freightCogsDisplay',
		//	label: 'Freight / Delivery COGs'
	},
	{
		sortId: 'cogsPerGallon',
		displayId: 'cogsDisplay',
		label: 'Freight / Delivery COGs',
	},
	{
		sortId: 'profitPerGallon',
		displayId: 'profitsDisplay',
		label: 'Profits',
	},
];

const invoiceColumns = [
	{
		sortId: 'status',
		displayId: 'statusDisplay',
		label: 'Status',
	},
	{
		sortId: 'deliveryDateSort2',
		displayId: 'invoiceDisplay',
		label: 'Invoice Info',
	},
	{
		sortId: 'deliveryDateSort',
		displayId: 'deliveryDisplay',
		label: 'Delivery Info',
	},
	{
		sortId: 'deliveryDateSort3',
		displayId: 'vendorBillDisplay',
		label: 'Vendor Bill Info',
	},
	{
		sortId: 'totalInvoiceE85LineItemCost',
		displayId: 'invoiceAmountsDisplay',
		label: 'Invoice Amounts',
	},
	{
		sortId: 'fuelCostPerGallon',
		displayId: 'fuelCogsDisplay',
		label: 'Fuel COGs',
		// }, {
		//	sortId: 'freightCostPerGallon',
		//	displayId: 'freightCogsDisplay',
		//	label: 'Freight / Delivery COGs'
	},
	{
		sortId: 'cogsPerGallon',
		displayId: 'cogsDisplay',
		label: 'Freight / Invoice COGs',
	},
	{
		sortId: 'profitPerGallon',
		displayId: 'profitsDisplay',
		label: 'Profits',
	},
];

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir} style={{ padding: 8 * 2 }}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};
class ProfitReportSearch extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			tabIndex: 0,
			formFieldError: {},
			deliveryType: 'station',
			invoiceType: 'station',
			yearMonth: moment().format('YYYY-MM'),
			includeTankTransfers: false,
			searchResultRows: undefined,
			isSearching: false,
		};
	}

	componentDidMount() {
		//- Only used for updates
		// const {} = this.props;
	}

	getApiParams = () => {
		const { accessToken } = this.props;
		const { yearMonth, deliveryType, invoiceType, includeTankTransfers } = this.state;

		const yearMonthMoment = yearMonth ? moment(yearMonth, 'YYYY-MM') : moment();
		return {
			accessToken,
			month: yearMonthMoment.month(),
			year: yearMonthMoment.year(),
			includeTankTransfers,
			deliveryType,
			invoiceType,
		};
	};

	//
	// By Delivery!
	//
	submitDeliverySearch = () => {
		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		this.setState({
			isSearching: true,
		});

		const params = this.getApiParams();
		const { deliveryType } = this.state;

		post({
			method: 'profitReport.search',
			params,
			callback: (err, apiSearchResult) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				if (deliveryType === 'bulk') {
					const { cogs, errors } = this.formatBulkCogs({
						apiSearchResult,
					});

					this.setState({
						isSearching: false,
						deliveryErrors: errors,
						deliveryBulkCogs: cogs,
					});
				} else {
					const { cogs, errors } = this.formatStationCogs({
						apiSearchResult,
					});

					this.setState({
						isSearching: false,
						deliveryErrors: errors,
						deliveryStationCogs: cogs,
					});
				}
			},
		});
	};

	//
	// By Invoice
	//
	submitInvoiceSearch = () => {
		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		this.setState({
			isSearching: true,
		});

		const params = this.getApiParams();
		const { invoiceType } = this.state;

		post({
			method: 'profitReport.byInvoice.search',
			params,
			callback: (err, apiSearchResult) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				if (invoiceType === 'bulk') {
					const { cogs, errors } = this.formatBulkCogs({
						isInvoiceSearch: true,
						apiSearchResult,
					});

					this.setState({
						isSearching: false,
						invoiceErrors: errors,
						invoiceBulkCogs: cogs,
					});
				} else {
					try {
						const { cogs, errors } = this.formatStationCogs({
							isInvoiceSearch: true,
							apiSearchResult,
						});

						this.setState({
							isSearching: false,
							invoiceErrors: errors,
							invoiceStationCogs: cogs,
						});
					} catch (e) {
						this.setState({
							isSearching: false,
						});
						throw e;
					}
				}
			},
		});
	};

	formatStationCogs = formatStationCogs.bind(this);
	formatBulkCogs = formatBulkCogs.bind(this);

	handleTabChange = (_event, tabIndex) => {
		this.setState({ tabIndex });
	};

	handleChangeTabIndex = (index) => {
		this.setState({ tabIndex: index });
	};

	render() {
		const { classes, theme } = this.props;
		const {
			deliveryType,
			deliveryBulkCogs,
			deliveryStationCogs,
			deliveryErrors,

			invoiceType,
			invoiceBulkCogs,
			invoiceStationCogs,
			invoiceErrors,
		} = this.state;

		const deliveryRows = deliveryType === 'bulk' ? deliveryBulkCogs : deliveryStationCogs;
		const invoiceRows = invoiceType === 'bulk' ? invoiceBulkCogs : invoiceStationCogs;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline label="Profit Report Search" />

					<AppBar position="static" color="default">
						<Tabs
							value={this.state.tabIndex}
							onChange={this.handleTabChange}
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
							centered
						>
							<Tab label="Profit By Delivery" icon={<TruckIcon />} />
							<Tab label="Profit By Invoice" icon={<InvoiceIcon />} />
						</Tabs>
					</AppBar>

					<Paper className={classes.paper}>
						<SwipeableViews
							axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
							index={this.state.tabIndex}
							onChangeIndex={this.handleChangeTabIndex}
						>
							<TabContainer dir={theme.direction}>
								<Grid container spacing={3}>
									<FMPSelect
										{...this.setForm('deliveryType', 'Delivery Type', true)}
										options={[
											{ value: 'station', display: 'Station Deliveries' },
											{ value: 'bulk', display: 'Bulk Deliveries' },
										]}
									/>

									{this.renderSearchParams()}
								</Grid>

								{!_.isEmpty(deliveryErrors) && this.renderErrors(deliveryErrors)}

								<div className={classes.divider} />
								{_.isEmpty(deliveryRows) && <div className={classes.resultsHere}>Results here</div>}
								{!_.isEmpty(deliveryRows) && (
									<EnhancedTable
										isDense={true}
										columns={stationColumns}
										rows={deliveryRows}
										defaultOrder={'asc'}
										defaultOrderBy={'deliveryDateSort'}
									/>
								)}
							</TabContainer>
							<TabContainer dir={theme.direction}>
								<Grid container spacing={3}>
									<FMPSelect
										{...this.setForm('invoiceType', 'Invoice Type', true)}
										options={[
											{ value: 'station', display: 'Station Invoices' },
											{ value: 'bulk', display: 'Bulk Invoices' },
										]}
									/>

									{this.renderInvoiceSearchParams()}
								</Grid>

								{!_.isEmpty(invoiceErrors) && this.renderErrors(invoiceErrors)}

								<div className={classes.divider} />
								{_.isEmpty(invoiceRows) && <div className={classes.resultsHere}>Results here</div>}
								{!_.isEmpty(invoiceRows) && (
									<EnhancedTable
										isDense={true}
										columns={invoiceColumns}
										rows={invoiceRows}
										defaultOrder={'asc'}
										defaultOrderBy={'deliveryDateSort2'}
									/>
								)}
							</TabContainer>
						</SwipeableViews>
					</Paper>
				</Grid>
			</Grid>
		);
	}

	renderErrors = (errors) => {
		const { classes } = this.props;
		return (
			<div className={classes.paper} style={{ marginTop: 20 }}>
				<div style={{ paddingBottom: 10, fontSize: '120%' }}>
					<WarningIcon className={classes.warningIcon} />
					<strong>Analysis Errors</strong>
				</div>
				{errors.map((error, i) => {
					return (
						<div key={i} style={{ padding: 5 }}>
							{error}
						</div>
					);
				})}
			</div>
		);
	};

	renderSearchParams = () => {
		const { classes } = this.props;
		const { isSearching, deliveryType } = this.state;

		const isBulk = deliveryType === 'bulk';

		const params = this.getApiParams();
		params.downloadCsv = true;
		const request = {
			method: 'profitReport.search',
			params,
		};

		let host = '';
		if (isLocalhost) {
			host = 'http://localhost:3700';
		}
		const downloadUrl = `${host}/api?request=${JSON.stringify(request)}`;

		return (
			<>
				<FMPMonthYearPicker {...this.setForm('yearMonth')} />

				{isBulk && (
					<FMPCheckbox
						{...this.setForm(
							'includeTankTransfers',
							'Include Tank Transfers (Bulk Customer RTC Fuels)',
							false,
							false
						)}
					/>
				)}

				<Grid container spacing={3}>
					<Grid item md={8} style={{ paddingTop: 25, display: 'flex' }}>
						<Button
							className={classes.bigButton}
							variant="contained"
							color="primary"
							onClick={this.submitDeliverySearch}
						>
							<Search />
							Delivery Profit Search
						</Button>

						<a
							href={downloadUrl}
							style={{ textDecoration: 'none', paddingRight: 5 }}
							target="_blank"
							rel="noreferrer noopener"
						>
							<Button
								className={classes.bigButton}
								variant="contained"
								color="primary"
								style={{ marginLeft: 10 }}
							>
								<DownloadIcon className={classes.icon} />
								Search & Download
							</Button>
						</a>

						{isSearching && (
							<div className={classes.runningSearch}>
								<CircularProgress />
								<span style={{ paddingLeft: 10 }}>Searching...</span>
							</div>
						)}
					</Grid>
				</Grid>
			</>
		);
	};

	renderInvoiceSearchParams = () => {
		const { classes } = this.props;
		const { isSearching } = this.state;

		const params = this.getApiParams();
		params.downloadCsv = true;
		const request = {
			method: 'profitReport.byInvoice.search',
			params,
		};

		let host = '';
		if (isLocalhost) {
			host = 'http://localhost:3700';
		}
		const downloadUrl = `${host}/api?request=${JSON.stringify(request)}`;

		return (
			<>
				<FMPMonthYearPicker {...this.setForm('yearMonth')} />
				<Grid container spacing={3}>
					<Grid item md={8} style={{ paddingTop: 25, display: 'flex' }}>
						<Button
							className={classes.bigButton}
							variant="contained"
							color="primary"
							onClick={this.submitInvoiceSearch}
						>
							<Search />
							Invoice Profit Search
						</Button>

						<a
							href={downloadUrl}
							style={{ textDecoration: 'none', paddingRight: 5 }}
							target={'_blank'}
							rel="noreferrer noopener"
						>
							<Button
								className={classes.bigButton}
								variant="contained"
								color="primary"
								style={{ marginLeft: 10 }}
							>
								<DownloadIcon className={classes.icon} />
								Search & Download
							</Button>
						</a>

						{isSearching && (
							<div className={classes.runningSearch}>
								<CircularProgress />
								<span style={{ paddingLeft: 10 }}>Searching...</span>
							</div>
						)}
					</Grid>
				</Grid>
			</>
		);
	};
}

ProfitReportSearch.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object,
	canMakeUpdates: PropTypes.bool,
	accessToken: PropTypes.string,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	BulkCustomersContainer,
	StationsContainer,
	CarriersContainer,
	TerminalsContainer,
	SuppliersContainer,
])(ProfitReportSearch);
